/* Chozen Solutions standard actions.
   Scope: menu wording/order, permanent Blueprint links,
   Featured Collections routing, and Gold-member caret tint.
*/
(function () {
  var blueprintUrl = 'https://calendly.com/davis-chozensolutions/door-two-merchandise-partnership-blueprint';
  var standardActionsScriptUrl = document.currentScript && document.currentScript.src;

  function normalizeText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function textNodes(root) {
    if (!root) return [];
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        return node.parentElement &&
          !/^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA)$/i.test(node.parentElement.tagName)
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_REJECT;
      }
    });
    var nodes = [], node;
    while ((node = walker.nextNode())) nodes.push(node);
    return nodes;
  }

  function renameAllProducts() {
    textNodes(document.body).forEach(function (node) {
      if (normalizeText(node.nodeValue) === 'All Products') {
        node.nodeValue = node.nodeValue.replace(/All Products/g, 'Shop All');
      }
    });
    document.querySelectorAll('[aria-label],[title]').forEach(function (el) {
      ['aria-label', 'title'].forEach(function (attr) {
        var value = el.getAttribute(attr);
        if (value && normalizeText(value) === 'All Products') {
          el.setAttribute(attr, value.replace(/All Products/g, 'Shop All'));
        }
      });
    });
  }

  function enforceBlueprintLinks() {
    document.querySelectorAll('a[href]').forEach(function (link) {
      var href = (link.getAttribute('href') || '').toLowerCase();
      var label = normalizeText(link.textContent).toLowerCase();
      var isBlueprint = label.indexOf('blueprint') !== -1 ||
        label.indexOf('schedule strategy session') !== -1 ||
        label.indexOf('strategy session') !== -1 ||
        href.indexOf('/pages/discovery-call') !== -1 ||
        href.indexOf('calendly.com/chozensolutions') !== -1;
      if (isBlueprint) {
        link.setAttribute('href', blueprintUrl);
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
      }
    });
  }

  function routeFeaturedCollections() {
    document.querySelectorAll('a[href]').forEach(function (link) {
      var label = normalizeText(link.textContent).toLowerCase();
      var aria = normalizeText(link.getAttribute('aria-label')).toLowerCase();
      if (label === 'view all collections' || aria === 'view all collections') {
        link.setAttribute('href', '/pages/shop-collections');
      }
    });
  }

  function reorderCollectionsMenu() {
    var desired = [
      'My Sisters Global Alliance',
      'The Legacy & Heritage Collection',
      'Chozen',
      'VAR540',
      'The Macon Apparel Company',
      'We Are Not Emotional',
      'Super Sunday School',
      'All Collections'
    ];
    document.querySelectorAll('.mega-menu__content ul, .menu-drawer__submenu ul').forEach(function (list) {
      var rows = Array.from(list.children);
      var byText = {};
      rows.forEach(function (row) {
        var label = normalizeText(row.textContent);
        if (desired.indexOf(label) !== -1) byText[label] = row;
      });
      desired.forEach(function (label) {
        if (byText[label]) list.appendChild(byText[label]);
      });
    });
  }

  function loadContactPolish() {
    if (!document.querySelector('.chozen-contact')) return;
    if (!standardActionsScriptUrl) return;
    if (document.querySelector('link[data-chozen-contact-polish]')) return;

    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = new URL('contact-page-polish.css', standardActionsScriptUrl).href;
    link.setAttribute('data-chozen-contact-polish', '');
    document.head.appendChild(link);
  }

  function init() {
    loadContactPolish();
    renameAllProducts();
    enforceBlueprintLinks();
    routeFeaturedCollections();
    reorderCollectionsMenu();
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', init);
  window.setTimeout(init, 1200);
})();
